import { render, staticRenderFns } from "./AnalyticsNews.vue?vue&type=template&id=f465c31e"
import script from "./AnalyticsNews.vue?vue&type=script&lang=js"
export * from "./AnalyticsNews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports